import { useState } from '@wordpress/element';
import LazyImage from '../LazyImage';
import CartProductVariants from './CartProductVariants';
import SpecialOffer from '../Products/SpecialOffer';

const CartProduct = ({ items, pricingType, surfside, analytics }) => {
    const [errors, setErrors] = useState([]);

    return (
        <div className='headless-cart-sidebar-item'>
            {items[0].isDiscounted && (
                <div className='headless-cart-sidebar-item-special'>
                    <SpecialOffer type='discount' />
                </div>
            )}
            <div
                id={items[0].productId}
                className={`headless-cart-product-top ${items[0].isDiscounted
                    ? 'headless-cart-product-discounted'
                    : ''
                    }`}
            >
                <div className='headless-cart-product-image'>
                    <LazyImage
                        src={`${items[0].product.image}?w=250`}
                        alt={`${items[0].product.name} image`}
                    />
                </div>
                <div className='headless-cart-product-title'>
                    {items[0].product.name}
                </div>
            </div>

            <div
                id={`item-${items[0].productId}`}
                className='headless-cart-sidebar-table'
            >
                <CartProductVariants
                    items={items}
                    pricingType={pricingType}
                    setErrors={setErrors}
                    surfside={surfside}
                    analytics={analytics}
                />

                {errors.length > 0 &&
                    errors.map((error, i) => (
                        <small key={i}>
                            <code>{error}</code>
                        </small>
                    ))}
            </div>
        </div>
    );
};

export default CartProduct;
